import React from 'react';
// Shared imports
import settings from '../../../settings';

class MainNavigation extends React.Component {
    BackButton = () => {
        const {BtnBackClass, BtnBackText, BtnBackAlt, OnBack} = this.props;
        return (
            <div className={`back-container ${BtnBackClass}`} onClick={OnBack}>
                <img src={`${settings.assetsPath}/img/icons/pijl.png`} alt={BtnBackAlt} title="Terug naar levels" />
                <span>{BtnBackText}</span>
            </div>
        );
    };

    GameStudioButton = () => {
        return (
            <a draggable="false" className="gamestudio-link" href="/">
                <img draggable="false" src={`${settings.assetsPath}img/gamestudio_logo_liggend.svg`} alt="Terug naar game studio" title="Terug naar game studio" />
            </a>
        );
    };

    render = () => {
        return (
            <div id="main-navigation">
                <this.BackButton />
                <this.GameStudioButton />
            </div>
        );
    };
}

MainNavigation.defaultProps = {
    BtnBackClass: "",
    BtnBackText: "",
    BtnBackAlt: "",
    OnBack: () => {}
};

export default MainNavigation;
